import { CanUpdateTripOutput } from '@allocab/allocab-passenger-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';

const fetchCanUpdateTrip = (key: string) => passengerApi.get<void, CanUpdateTripOutput>(`v2/trip/${key}/can-update`);

export const useFetchCanUpdateTrip = (key: string) =>
  useQuery(queryKeys.user.fetchCanUpdateTrip(key), () => fetchCanUpdateTrip(key));
